import { render } from "./AdminCharacterView.vue?vue&type=template&id=e3e83fc2&scoped=true"
import script from "./AdminCharacterView.vue?vue&type=script&lang=js"
export * from "./AdminCharacterView.vue?vue&type=script&lang=js"

import "./AdminCharacterView.vue?vue&type=style&index=0&id=e3e83fc2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e3e83fc2"]])

export default __exports__